import http from "@seims/shared/src/services/HttpService";

const endpoint = `/citizen/science/`;
const lookupEndpoint = `/lookup/citizen/science/`;
const eventEndpoint = `/events/`;


const getOrganizations = async ({ first, max, searchText = undefined, ownRecords=false}) => {
  //   const response = await http.get(`${endpoint}organisations?offset=${first}&limit=${max}&searchText=${searchText}`);
  const response = await http.get(`${endpoint}organisations?offset=${first}&limit=${max}&searchText=${searchText}&ownRecords=${ownRecords}`);
  return response;
}

const saveSciProject = (data) => {

  const response = http.post(`${endpoint}project/save`, data);
  return response;
};

const editProject = async (data, projectId) => {
   const response = await http.put(`${endpoint}${projectId}`, data);
   return response;
};

const closeProject = async (data,projectId) => {
  const response = await http.patch(`${endpoint}projects?projectId=${projectId}`, data);
  return response;
};

const addParticipant = async (data, projectId) => {

  const response = await http.post(`${endpoint}project/participants?projectId=${projectId}`, data);
  return response;
};

const editParticipant = async (data, projectId, participantId) => {

   const response = await http.put(`${endpoint}project/participants?projectId=${projectId}&participantId=${participantId}`, data);
   return response;
};

const getProjects = async () => {
  const response = await http.get(`${endpoint}project/summary/list`);
  return response;
}
const getUserProjects = async (userId) => {
  const response = await http.get(`${endpoint}identifier/${userId}`);
   return response;
}

const getProjectDetails = async (projectId) => {
  const response = await http.get(`${endpoint}view/${projectId}`);
  return response;
};


const getParticipant = async (projectId, participantId) => {
  const response = await http.get(`${endpoint}project/participants?projectId=${projectId}&participantId=${participantId}`);
   return response;
};

const getProjectStatuses = async () => {
  const response = await http.get(`${lookupEndpoint}status`);
  return response;
};

const addPartnership = async (
  partner, address
) => {
  const entity = "partner";
  let msg = "";



  const response = await http.post(
    `${endpoint}organisations`,
    {
      "id": -1,
      "uuid": "00000000-0000-0000-0000-000000000000",
      "name": partner.name,
      "initiationDate": new Date().toISOString(),
      "lastEngagementDate": new Date().toISOString(), //still to be confirmed
      "telephoneNumber": partner.contact,
      "email": partner.email,
      "archived": false,
      "representatives": [],
      "contributions": partner.contributions,
      "otherContribution": partner.otherContribution,
      "partnerType": partner.partnerType,
      "locality": 0,
      "active": true,
      "reportedOn": true,
      "address": {
        "id": -1,
        "country": address.country,
        "province": address.province,
        "cityOrTown": address.cityOrTown,
        "street": address.street,
        "postalCode": address.postalCode,
      },

    },
  );
  return response;
};

const getRatifiedProjects = async ({ first, max, domain, location}) => {
  const response = await http.get(`${endpoint}participation/projects?offset=${first}&limit=${max}&category=${domain}&location=${location}`);
  return response;
}

const getProjectParticipant = async (projectId, participantId) => {
  const response = http.get(`${endpoint}project/particiapants/${projectId}/${participantId}`);
  return response;
};



const searchProjecttDetails = async (projectId) => {
  const response = http.get(`${endpoint}participation/projects/${projectId}`);
  return response;
};

const addParticipantData = async ({data, projectId}) => {
  const response = http.post(`${endpoint}participation/projects/${projectId}`, data);

  return response;
}

const checkEmailExists = async (email) => {
  const response = await http.get(`${eventEndpoint}email/valid/${email}`, {
  });

  return response;
};
const getParticipnatsSwitch = async (projectId, acceptingParticipants) => {
  const response = http.patch(`${endpoint}project/participants?projectId=${projectId}&acceptingParticipants=${acceptingParticipants}`);

  return response;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getOrganizations,
  addPartnership,
  saveSciProject,
  getProjects,
  getUserProjects,
  getProjectDetails,
  getRatifiedProjects,
  searchProjecttDetails,
  addParticipantData,
  getProjectStatuses,
  getProjectParticipant,
  editParticipant,
  getParticipant,
  addParticipant,
  editProject,
  checkEmailExists,
  closeProject,
  getParticipnatsSwitch
}
